import React from 'react';
import Infinite from 'react-infinite';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

const InfiniteScroll = ({
  elements,
  isInfiniteLoading,
  heightIdx,
  columns,
  test,
  noDataText,
  handleInfiniteLoad,
  elementInfiniteLoad,
  containerHeight,
  onClickHandler
}) => {
  let num = heightIdx === 0 ? containerHeight + 1 : heightIdx;
  const style = {
    maxHeight: String(num) + 'px',
    minHeight: '120px'
  };

  return (
    <Infinite
      className="infinite-scroll"
      elementHeight={10}
      containerHeight={containerHeight}
      infiniteLoadBeginEdgeOffset={num}
      onInfiniteLoad={handleInfiniteLoad}
      loadingSpinnerDelegate={elementInfiniteLoad}
      isInfiniteLoading={isInfiniteLoading}
    >
      <ReactTable
        className="react-table"
        noDataText={noDataText ? noDataText : '검색 결과가 없습니다.'}
        style={style}
        data={elements}
        columns={columns}
        sortable={false}
        resizable={false}
        showPagination={false}
        pageSize={elements ? elements.length : 0}
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              // console.log('A Td Element was clicked!')
              // console.log('it produced this event:', e)
              // console.log('It was in this column:', column)
              // console.log('It was in this row:', rowInfo)
              // console.log('It was in this table instance:', instance)
              if (handleOriginal && onClickHandler) {
                onClickHandler(column, rowInfo);
              }
            }
          };
        }}
      />
    </Infinite>
  );
};

export default InfiniteScroll;
